import { render, staticRenderFns } from "./BuildingShowOptionSettingsTab.vue?vue&type=template&id=654c82ee"
import script from "./BuildingShowOptionSettingsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowOptionSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./BuildingShowOptionSettingsTab.vue?vue&type=style&index=0&id=654c82ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports